import { BaseComponent2 } from '../../_common/client/base-component2';
import { registerClickTracking } from './register-click-tracking';

export class TopInfoComponent extends BaseComponent2 {
    public rootSelector = '.js_pdp_top-info';

    public async init(): Promise<void> {
        if (!this.isPresent()) return;
        const listElement = this.getRootElement().querySelector<HTMLElement>('.pdp_top-info__list');
        if (listElement === null) {
            return;
        }
        registerClickTracking(listElement);
    }
}
